import React, { ReactNode } from "react";
import { PhoneFrame } from "./index";
import { cn } from "../../lib/utils";

interface PhonePreviewProps {
  children: ReactNode;
  showStatusBar?: boolean;
  showHomeIndicator?: boolean;
  className?: string;
  contentClassName?: string;
  frameClassName?: string;
}

export const PhonePreview = ({
  children,
  showStatusBar = true,
  showHomeIndicator = true,
  className,
  contentClassName,
  frameClassName,
}: PhonePreviewProps) => (
  <div className={cn("flex justify-center", className)}>
    <div className="relative">
      <PhoneFrame
        showStatusBar={showStatusBar}
        showHomeIndicator={showHomeIndicator}
        className={frameClassName}
        contentClassName={contentClassName}
      >
        {children}
      </PhoneFrame>
    </div>
  </div>
);
